import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Pagination } from '@mui/material';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, CardActions, IconButton, Button, Modal, Box, Divider, FormControl, Select, InputLabel, TextField, MenuItem, Typography, Backdrop, CircularProgress, Theme, SelectChangeEvent, OutlinedInput, Chip, Dialog, DialogTitle, DialogActions, Autocomplete, FormControlLabel, Switch } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Routes from './Routes';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams, GridRenderCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, CloseOutlined } from '@mui/icons-material';
import debounce from 'lodash.debounce';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import id from 'date-fns/esm/locale/id/index.js';
import { formatDate } from '../../helpers/custom';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
}
// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

// function getStyles(name: string, personName: readonly string[], theme: Theme) {
//     return {
//       fontWeight:
//         personName.indexOf(name) === -1
//           ? theme.typography.fontWeightRegular
//           : theme.typography.fontWeightMedium,
//     };
//   }


export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchyIds: any;
        selectedHierarchies: any;
    };
}

interface MarkerProps {
    lat: number;
    lng: number;
    label?: string;
}

export interface IState {
    communitiesList: any[];
    pageSize: number;
    showAddRoute: boolean;
    community_name: string;
    city_id: any;
    community_address: string;
    type: string;
    pincode: string;
    priority: string;
    filter: any;
    community_type: any;
    rowCount: any;
    routes: any;
    showLoader: boolean;
    community_id: any;
    showCreateUsers: boolean;
    userCommunity: any;
    userCount: any;
    showEditCommunityTemplate: boolean;
    pickupDays: any;
    pickupSlot: any;
    agents: any;
    pickupAgent: any;
    distributionDate: any;
    distributionAgent: any;
    weekDays: any;
    showDeleteDialogue: boolean;
    hierarchiesList: any[];
    flagEditTemplate: boolean;
    pickupEnabled: any;
    bagDistributionEnabled: any;
    toggleCommunityId: any;
    toggleCommunityStatus: any;
    showToggleDialogBox: boolean;
    currentPage: number;
    showMapView: boolean, 
    markers: MarkerProps[];
    defaultMapCenter: MarkerProps;
    previewLat: string;
    previewLng: string;

    from_date?: string | null;
    to_date?: string | null;
    longitude: string,
    latitude: string,
    sec_type: string,
    showPreviewModal: boolean;
}

class NeighbourhoodList extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            communitiesList: [],
            pageSize: 10,
            showAddRoute: false,
            community_name: "",
            city_id: "",
            community_address: '',
            type: '',
            pincode: '',
            priority: 'New',
            currentPage: 0,
            filter: null,
            community_type: 'all',
            rowCount: 0,
            routes: [],
            showLoader: false,
            community_id: '',
            showCreateUsers: false,
            userCommunity: null,
            userCount: "",
            showEditCommunityTemplate: false,
            pickupDays: [],
            pickupSlot: '',
            agents: [],
            pickupAgent: '',
            distributionDate: null,
            distributionAgent: '',
            weekDays: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
            showDeleteDialogue: false,
            hierarchiesList: [],
            flagEditTemplate: false,
            previewLat: '',
            previewLng: '',
            pickupEnabled: true,
            bagDistributionEnabled: true,
            toggleCommunityId: '',
            toggleCommunityStatus: '',
            longitude: '',
            latitude: '',
            sec_type: 'New',
            showPreviewModal: false,
            showToggleDialogBox: false,

            from_date: null,
            to_date: null,
            showMapView: false, 
            markers: [],
            defaultMapCenter: { lat: 22.5937, lng: 78.9629 }
        }
       
    }
    public componentDidMount(): void {
        
        this.fetchRoutes();
        this.fetchAgents();
        this.fetchNeighbourhood();
        this.fetchAccessibleHierarchies();
        this.fetchAllCommunitiesCoordinates();
    }

    public fetchRoutes() {
        axios.get(`allCommunitiesLite`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            let data: any = response.data.data;
            // let routes: any = [];
            // data.map((route: any) => {
            //     routes[route.id] = {
            //         id: route.id,
            //         route: route.name,
            //         hierarchy_id: route.hierarchy_id,
            //         hierarchy_name: route.hierarchy_name,
            //     };
            // });
            this.setState({ routes: data });
            // console.log("communities", this.state.routes);
        });
    }

    public fetchAllCommunitiesCoordinates() {
        axios.get(`allCommunitiesCoordinates`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            let data: any = response.data.data;
            let markers =  this.state.markers;
            let defaultMapCenter = this.state.defaultMapCenter;
            data.map((marker:any, key: number) => {
                if(key == 0){
                    defaultMapCenter = { lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude) }
                }
                markers.push(
                    { lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude), label: marker.name }
                )
            })
            this.setState({ markers });
        });
    }

    public fetchAgents() {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds }
            axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let agents: any = response.data.data;
                this.setState({ agents: agents });
            });
        }
    }

    public fetchNeighbourhood = (page: number = 0, limit: number = this.state.pageSize) => {
        this.setState({ showLoader: true,currentPage: page});
        let from_date = (this.state.from_date) ? formatDate(this.state.from_date, 'Y-m-d') : "";
        let to_date = (this.state.to_date) ? formatDate(this.state.to_date, 'Y-m-d') : "";
        let body = {
            "hierarchies": this.props.user.selectedHierarchyIds,
            "page": page+1,
            "limit": limit,
            "filter": this.state.filter?.name,
            "type": this.state.community_type != 'all' ? this.state.community_type : '',
            "from_date": from_date,
            "to_date": to_date
        }
        axios.post('allCommunities', body, { headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                // console.log("allcommunities", response.data.data.data); 
                this.setState({rowCount: response.data.data.total, showLoader: false});
                let data = response.data.data.data;
                // console.log("data", data);
                let list = data.map((el: any) => {
                    return{
                        "id": el.id,
                        "community": el.name,
                        "zone": el.zone,
                        "members": el.user_count?.count,
                        "address": el.address, 
                        "type": el.type,
                        "pincode": el.pincode,
                        "priority": el.priority_type,
                        "hierarchy": el.hierarchy.id,
                        "status": el.is_active,
                        "pickup_enabled": el.pickup_enabled,
                        "pickup_date": el.pickup_ref_date,
                        "pickup_agent": el.pickup_agent?.name,
                        "pickup_agent_id": el.pickup_ref_agent,
                        "pickup_slot": el.slot?.text,
                        "bag_date": el.bag_ref_date,
                        "bag_agent": el.bag_agent?.name,
                        "bag_agent_id": el.bag_ref_agent,
                        "bag_distribution_enabled": el.bag_distribution_enabled,
                        "bag_ref_date": el.bag_ref_date,
                        "slot": el.slot,
                        "pickup_ref_days": el.pickup_ref_days,
                        "created_at": formatDate(el.created_at),
                        "latitude": el.latitude,
                        "longitude": el.longitude,
                        "sec_type": el.sec_type,
                    }
                })
                this.setState({communitiesList: [...list]});
                // console.log("commList",this.state.communitiesList)

            } else {
                this.setState({showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchAccessibleHierarchies = () => {
        axios.get('accessibleHierarchiesList').then((response: any) => {
            // console.log("response:", response.data.data);
            if(response.data.success){
                let selectedHierarchyIds = this.props.user.selectedHierarchyIds || [];
                let hierarchiesList = response.data.data.filter((hierarchy: any) => selectedHierarchyIds.includes(hierarchy.id));
                this.setState({hierarchiesList: hierarchiesList});
            } else {
                this.setState({showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public toggleCommunityStatus = () => {
        let data = {
            'hierarchies': this.props.user.selectedHierarchyIds,
            'community_id': this.state.toggleCommunityId,
        }
        axios.post('toggleCommunityStatus', data, {headers: {'contentType': 'application/json'}}).then((response: any) => {
            if(response.data.success){
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchNeighbourhood();
                this.setState({showToggleDialogBox: false, toggleCommunityId: '', toggleCommunityStatus: ''});
            } else {
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
                this.setState({showToggleDialogBox: false, toggleCommunityId: '', toggleCommunityStatus: ''});
            }
        })
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchNeighbourhood(page,limit);
      }, 800);

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const maskedCellSx = isUatEnvironment
            ? {
                filter: 'blur(4px)',
                opacity: 0.5,
                userSelect: 'none',
            }
            : undefined;
        const renderMaskedCell = (value: React.ReactNode) => (
            <Box component="span" sx={maskedCellSx}>
                {value}
            </Box>
        );

        const handleAddCommunity = (() => {
            this.setState({ showAddRoute: false });
            let body = {
                "name": this.state.community_name,
                "address" : this.state.community_address,
                "hierarchies": this.state.city_id,
                "pincode": this.state.pincode,
                // "priority_type": this.state.priority,
                "type": this.state.type,
                "latitude": this.state.latitude,
                "longitude": this.state.longitude,
            }
            axios.post("addCommunity", body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
                if(response.data.success){
                    this.setState({showLoader: false, showAddRoute: false,  community_id: '', community_name: "", community_address: "", city_id: "", pincode: "", priority: "", type: "", latitude: "", longitude: ""});
                    toast.success("Community added", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchNeighbourhood();
                    this.fetchRoutes();
                } else {
                    this.setState({ showAddRoute: false, community_name: "", community_address: "", city_id: "", pincode: "", priority: "", type: "", latitude: "", longitude: "", showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showAddRoute: false,  community_name: "", community_address: "", city_id: "", pincode: "", priority: "", type: "", latitude: "", longitude: "", showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const createBulkUsers = () => {
            this.setState({showLoader: true});
            let body = {
                "community_id": this.state.userCommunity,
                "count": this.state.userCount
            }
            axios.post('createBulkCustomers', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
                if(response.data.success){
                    this.setState({showLoader: false, showCreateUsers: false});
                    toast.success("Successfully Created Customers!", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchNeighbourhood();
                } else {
                    this.setState({ showCreateUsers: false, userCommunity: "", userCount: "", showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showCreateUsers: false,  userCommunity: "", userCount: "", showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }
        const handleEditCommunity = () => {
            
            let body = {
                "hierarchies": [this.state.city_id],
                "id": this.state.community_id,
                "name": this.state.community_name,
                "address": this.state.community_address,
                "pincode": this.state.pincode,
                "type": this.state.type,
                // "priority_type": this.state.priority,
                "hierarchy_id": this.state.city_id,
                "community_id": this.state.community_id,
                // "id": this.state.community_id,
                // "name": this.state.community_name,
                // "address" : this.state.community_address,
                // "hierarchies": this.props.user.selectedHierarchyIds,
                // "pincode": this.state.pincode,
                // "priority_type": this.state.priority,
                // "type": this.state.type
                "latitude": this.state.latitude,
                "longitude": this.state.longitude,
            }
            axios.post("editCommunity", body, { headers: {"Content-Type": "application/json"}}).then((response: any) => {
                if(response.data.success){
                    this.setState({showLoader: false, showAddRoute: false, community_id: '', community_name: "", community_address: "", city_id: "", pincode: "", priority: "", type: ""});
                    toast.success("Community added", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchNeighbourhood();
                } else {
                    this.setState({ showAddRoute: false, community_id: '', community_name: "", community_address: "", city_id: "", pincode: "", priority: "", type: "", showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showAddRoute: false, community_id: '', community_name: "", community_address: "", city_id: "", pincode: "", priority: "", type: "", showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleShowEditCommunity = (el: any) => {
            this.setState({
                showAddRoute: true,
                community_id: el.id,
                community_name: el.community,
                community_address: el.address,
                // community_type: el.type,
                pincode: el.pincode,
                priority: el.priority,
                city_id: el.hierarchy,    
                type: el.type,
                latitude: el.latitude || '',
                longitude: el.longitude || '',
                sec_type: el.sec_type
            })
        } 

        const handleShowEditCommunityTemplate = (row: any) => {
            // console.log("row", row);
            if(row.pickup_ref_day || row.slot || row.pickup_agent_id || row.bag_ref_date){
                this.setState({flagEditTemplate: true});
            } else {
                this.setState({flagEditTemplate: false});
            }
            this.setState({
                showEditCommunityTemplate: true,
                // pickupDays: row.pickup_ref_day != null ? row.pickup_ref_days.split(",") : [],
                // pickupSlot: row.slot ? row.slot.id : '',
                // pickupAgent: row.pickup_agent_id != null ? row.pickup_agent_id : '',
                // distributionAgent: row.bag_agent_id != null ? row.bag_agent_id : '',
                // distributionDate: row.bag_ref_date != null ? row.bag_ref_date : null,
                pickupDays: row.pickup_ref_days != null ? row?.pickup_ref_days?.split(",") : [],
                pickupSlot: row?.slot?.id,
                pickupAgent: row?.pickup_agent_id,
                distributionAgent: row?.bag_agent_id,
                distributionDate: row?.bag_ref_date,
                community_id: row?.id,
                pickupEnabled: row?.pickup_enabled == 1 ? true : false,
                bagDistributionEnabled: row?.bag_distribution_enabled == 1 ? true : false,
            });
        }

        const handleSetCommunityTemplate = () => {
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "distribution_agent_id": this.state.distributionAgent,
                "community_id": this.state.community_id,
                "distribution_date": this.state.distributionDate,
                "pickup_agent_id": this.state.pickupAgent,
                "pickup_days": this.state.pickupDays.join(),
                "slot_id": this.state.pickupSlot,
                "bag_distribution_enabled": this.state.bagDistributionEnabled,
                "pickup_enabled": this.state.pickupEnabled 
            }
            axios.post('setCommunityTemplate', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
                if(response.data.success){
                    this.setState({showEditCommunityTemplate: false, pickupDays: [], pickupSlot: '', pickupAgent: '', distributionAgent: '', distributionDate: '', community_id: ''});
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchNeighbourhood();
                } else {
                    this.setState({showEditCommunityTemplate: false, pickupDays: [], pickupSlot: '', pickupAgent: '', distributionAgent: '', distributionDate: '', community_id: ''});
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({showEditCommunityTemplate: false, pickupDays: [], pickupSlot: '', pickupAgent: '', distributionAgent: '', distributionDate: '', community_id: ''});
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleChange = (event: SelectChangeEvent<typeof this.state.pickupDays>) => {
            const {
              target: { value },
            } = event;
            // setPersonName(
            //   // On autofill we get a stringified value.
            //   typeof value === 'string' ? value.split(',') : value,
            // );
            this.setState({pickupDays: typeof value === 'string' ? value.split(',') : value})
            // console.log("result", this.state.pickupDays);
          };

          const handleDeleteCommunity = (row: any) => {
            this.setState({showDeleteDialogue: true, community_id: row.id});
          }
        
          const deleteCommunity = (id: any) => {
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "community_id": id,
            }
            axios.post('deleteCommunity', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
                if(response.data.success){
                    this.setState({showDeleteDialogue: false});
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchNeighbourhood();
                } else {
                    this.setState({showDeleteDialogue: false});
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({showDeleteDialogue: false});
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
          }
        
        const toggleCommunityStatus = (id: any, status: any) => {
            this.setState({toggleCommunityId: id, toggleCommunityStatus: status, showToggleDialogBox: true});
        }
        const convertToTitleCase = (str: any) => {
            return str
                .split('')  // Split the string into an array of characters
                .map((char: any, index: any) => index === 0 ? char.toUpperCase() : char)  // Convert the first character to uppercase
                .join('');  // Join the characters back into a string
        };

        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <Link to={`/neighbourhood/community-list/${params.id}`} style={{ textDecoration: 'none' }}>{params.row.id}</Link>
                )
            },
            {
                headerName: "Community",
                field: "community",
                width: 400, 
                renderCell: (params: GridCellParams) => (
                    <Grid container spacing={2}>
                        <Grid item md={6} xs={12} className="mt-1" sx={{textAlign: 'left'}}>
                           <Link
                               to={`/neighbourhood/community-list/${params.row.id}`} 
                               style={{ textDecoration: 'none'}} 
                             >
                               {renderMaskedCell(
                                   <>
                                       {params.row.community} ({convertToTitleCase(params.row.type)})
                                   </>
                               )}
                            </Link>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <Link to={`/neighbourhood/community-list/${params.id}/users`} style={{ textDecoration: 'none' }}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    className="float-right"
                                    tabIndex={params.hasFocus ? 0 : -1}
                                    >
                                    Users
                                </Button>
                            </Link>
                        </Grid>
                    </Grid>
                        
                )
            },
            // {
            //     headerName: "Zone",
            //     field: "zone",
            //     width: 100
            // },
            {
                headerName: "Members",
                field: "members",
                width: 80,
                renderCell: (params: GridCellParams) => (
                    <div>{params.value}</div>
                  )
            },
            {
                headerName: "Address",
                field: "address",
                width: 180,
                renderCell: (params: GridCellParams) => (
                    <div>{renderMaskedCell(params.value)}</div>
                  )
            },
            {
                headerName: "Pincode",
                field: "pincode",
                width: 80,
                renderCell: (params: GridCellParams) => (
                    <div>{renderMaskedCell(params.value)}</div>
                  )
            },
            {
                headerName: "Onboarded Date",
                field: "created_at",
                width: 125,
                renderCell: (params: GridCellParams) => (
                    <div>{params.value}</div>
                  )
            },
            {
                headerName: "Priority",
                field: "priority",
                width: 80,
                renderCell: (params: GridCellParams) => (
                    <div>{(params.value) ? params.value : <Chip size="small" color="warning" label="New" />}</div>
                  )
            }, 
            {
                headerName: "Sec Type",
                field: "sec_type",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <div>{(params.value) ? params.value : <Chip size="small" color="warning" label="New" />}</div>
                )
            },                      
            {
                headerName: "Status",
                field: "status",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Button
                        variant={params.row.status == 1 ? "contained" : "outlined"}
                        size="small"
                        className="float-right"
                        color={params.row.status == 1 ? 'success' : 'error'}
                        // tabIndex={params.hasFocus ? 0 : -1}
                        onClick={() => toggleCommunityStatus(params.row.id, params.row.status)}
                        >
                        {params.row.status == 1 ? "Active" : "Inactive"}
                    </Button>
                )
              },
            // {
            //     headerName: "Status",
            //     field: "status",
            //     width: 100,
            //     renderCell: (params: GridCellParams) => (
            //         <Typography className={(params.row.status == 1) ? 'statusTextSuccess' : 'statusTextError'}>{params.row.status == 1 ? "Active" : "Inactive"}</Typography>
            //     )
            // },
            {
                headerName: "Pickup Date",
                field: "pickup_date",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <div>{params.value}</div>
                  )
            },
            {
                headerName: "Pickup Agent",
                field: "pickup_agent",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <div>{params.value}</div>
                  )
            },
            {
                headerName: "Pickup Slot",
                field: "pickup_slot",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <div>{params.value}</div>
                  )
            },
            {
                headerName: "Bag Date",
                field: "bag_date",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <div>{params.value}</div>
                )
            },
            {
                headerName: "Bag Agent",
                field: "bag_agent",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <div>{params.value}</div>
                )
            },
            {
                headerName: "Latitude",
                field: "latitude",
                hide: true
            },
            {
                headerName: "Longitude",
                field: "longitude",
                hide: true
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        // icon={<FileCopyIcon />}    
                        label="Edit Community Details"
                        onClick={() => handleShowEditCommunity(params.row)}
                        showInMenu
                    />,
                    <GridActionsCellItem
                        label="Community Template"
                        onClick={() => handleShowEditCommunityTemplate(params.row)}
                        showInMenu
                    />,
                    // <GridActionsCellItem
                    //     label="Delete Community"
                    //     onClick={() => handleDeleteCommunity(params.row)}
                    //     showInMenu
                    // />
                ]
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <NeighbourhoodHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{height: 600}}>
                            <CardHeader
                                title={
                                    <Grid container>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Community List")}</Typography>
                                        </Grid>
                                        <Grid item md={9} xs={12}>
                                            <Grid container spacing={2}>
                                                <Grid item md={3} xs={12}>
                                                    <Autocomplete
                                                        size="small"
                                                        id="combo-box-demo"
                                                        options={this.state.routes}
                                                        value={this.state.filter?.name}
                                                        onChange={(value: any, newValue: any) => this.setState({filter: newValue}, () => this.handleSearch())}
                                                        getOptionLabel={(options: any) => options.name}
                                                        renderInput={(params) => <TextField {...params} label="Search" />}
                                                    />
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <FormControl fullWidth={true} size="small">
                                                        <InputLabel id="route-type-label">{t("Type")}</InputLabel>
                                                        <Select
                                                            labelId="route-type-label"
                                                            value={this.state.community_type}
                                                            onChange={(e: any) => this.setState({ "community_type": e.target.value }, () => this.fetchNeighbourhood())}
                                                            displayEmpty
                                                            label={t("Type")}
                                                        >
                                                            <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                            <MenuItem key={'community'} value={'community'}>{t("Community")}</MenuItem>
                                                            <MenuItem key={'zone'} value={'zone'}>{t("Zone")}</MenuItem>
                                                            <MenuItem key={'society'} value={'society'}>{t("Society")}</MenuItem>
                                                            <MenuItem key={'corporate'} value={'corporate'}>{t("Corporate")}</MenuItem>

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <FormControl fullWidth={true}>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DatePicker
                                                                inputFormat="yyyy-MM-dd"
                                                                mask="____-__-__"
                                                                views={['year', 'month', 'day']}
                                                                renderInput={(props) => <TextField {...props} size='small' />}
                                                                label={t("From Date")}
                                                                value={this.state.from_date}
                                                                onChange={(newValue: any) => this.setState({ from_date: newValue }, () => this.fetchNeighbourhood())}
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item md={3} xs={12}>
                                                    <FormControl fullWidth={true}>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DatePicker
                                                                inputFormat="yyyy-MM-dd"
                                                                mask="____-__-__"
                                                                views={['year', 'month', 'day']}
                                                                renderInput={(props) => <TextField {...props} size='small' />}
                                                                label={t("To Date")}
                                                                value={this.state.to_date}
                                                                onChange={(newValue: any) => this.setState({ to_date: newValue }, () => this.fetchNeighbourhood())}
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button variant="contained" size='small' sx={{ outline: 'none !important' }}
                                            onClick={() => { this.setState({ showAddRoute: true }) }}
                                        >
                                            <Add /> {t("Add Community")}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            sx={{ outline: 'none !important' }}
                                            onClick={() => { this.setState({ showMapView: true }) }}
                                        >
                                            {t("View on Map")}
                                        </Button>
                                        <Button variant="contained" size='small' sx={{ outline: 'none !important' }}
                                            onClick={() => { this.setState({ showCreateUsers: true }) }}
                                        >
                                            {t("Create Users")}
                                        </Button>
                                    </CardActions>
                                }
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label="Route List"
                                    columns={columns}
                                    rows={this.state.communitiesList}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchNeighbourhood(page)}
                                    onPageSizeChange={(newPageSize) => {this.setState({ pageSize: newPageSize }); this.fetchNeighbourhood(0, newPageSize); }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{ height: 500 }}
                                    pagination 
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchNeighbourhood(page-1)}
                                                
                                            />
                                        )
                                    }}
                                    className="clickableList"
                                    paginationMode="server"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showAddRoute}
                    onClose={() => this.setState({ showAddRoute: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={this.state.community_id ? "Edit Community" : "Add Community"}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddRoute: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-name-input"
                                            label="Community Name *"
                                            value={this.state.community_name}
                                            onChange={(e: any) => this.setState({ community_name: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">City *</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.city_id}
                                                onChange={(e) => {
                                                    let temp : any = [];
                                                    temp.push(e.target.value);
                                                    this.setState({ city_id: [...temp] })
                                                }}
                                                displayEmpty
                                                label="City *"
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.hierarchiesList.map((element: any) => (
                                                        <MenuItem key={element.id} value={element.id}>{element.name}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label="Community Address *"
                                            value={this.state.community_address}
                                            onChange={(e: any) => this.setState({ community_address: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="type-label">Type *</InputLabel>
                                            <Select
                                                labelId="type-label"
                                                value={this.state.type}
                                                onChange={(e) => this.setState({ type: e.target.value })}
                                                displayEmpty
                                                label="Type *"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={'community'}>Community</MenuItem>
                                                <MenuItem key={2} value={'zone'}>Zone</MenuItem>
                                                <MenuItem key={3} value={'society'}>Society</MenuItem>
                                                <MenuItem key={4} value={'corporate'}>Corporate</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label="Pincode *"
                                            value={this.state.pincode}
                                            onChange={(e: any) => this.setState({ pincode: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="type-label">Priority</InputLabel>
                                            <Select
                                                labelId="type-label"
                                                value={(this.state.priority) ? this.state.priority : "New"}
                                                onChange={(e) => this.setState({ priority: e.target.value })}
                                                displayEmpty
                                                disabled
                                                label="Priority"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={0} value={"New"}>New</MenuItem>
                                                <MenuItem key={1} value={"P1"}>P1</MenuItem>
                                                <MenuItem key={2} value={"P2"}>P2</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="latitude-input"
                                            label="Latitude *"
                                            value={this.state.latitude}
                                            onChange={(e) => this.setState({ latitude: e.target.value, showPreviewModal: false })}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="longitude-input"
                                            label="Longitude *"
                                            value={this.state.longitude}
                                            onChange={(e) => this.setState({ longitude: e.target.value, showPreviewModal: false })}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="sec-type-label">Sec Type</InputLabel>
                                            <Select
                                                labelId="sec-type-label"
                                                value={(this.state.sec_type) ? this.state.sec_type : "New"}
                                                onChange={(e) => this.setState({ sec_type: e.target.value })}
                                                label="Sec Type"
                                                displayEmpty
                                                disabled
                                            >
                                                <MenuItem key={0} value="New">New</MenuItem>
                                                <MenuItem key={1} value="A1A2">A1A2</MenuItem>
                                                <MenuItem key={2} value="A3B1">A3B1</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {(this.state.latitude && this.state.longitude) && (
                                    <Grid item xs={12}>
                                        <Box display="flex" justifyContent="center" mt={2}>
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: '#204D36',
                                                    color: '#fff',
                                                    '&:hover': { backgroundColor: '#163726' }
                                                }}
                                                onClick={() => {
                                                    if (this.state.latitude && this.state.longitude) {
                                                      this.setState({ showPreviewModal: true });
                                                    } else {
                                                      toast.error('Please enter both latitude and longitude');
                                                    }
                                                  }}
                                            >
                                                Preview Location
                                            </Button>       
                                        </Box>
                                        {this.state.showPreviewModal && (
                                        <Box display="flex" justifyContent="center" mt={2}>
                                            <div className="map-container" style={{ width: '100%'}}>
                                            <LoadScript googleMapsApiKey={'AIzaSyCFqWukKnjwW2mFD8Yied3129Dic2TRWH4'}>
                                                <GoogleMap
                                               mapContainerStyle={{ width: '100%', height: '200px' }} 
                                                zoom={15}
                                                center={{
                                                    lat: parseFloat(this.state.latitude),
                                                    lng: parseFloat(this.state.longitude)
                                                }}
                                                >
                                                <Marker
                                                    position={{
                                                    lat: parseFloat(this.state.latitude),
                                                    lng: parseFloat(this.state.longitude)
                                                    }}
                                                />
                                                </GoogleMap>
                                            </LoadScript>
                                            </div>
                                        </Box>
                                        )}
                                    </Grid>
                                )}
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddRoute: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.state.community_id? handleEditCommunity() : handleAddCommunity()}>{this.state.community_id? "Edit Community": "Add Community"}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                open={this.state.showMapView}
                onClose={() => this.setState({ showMapView: false })}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <Box sx={style}>
                    <Card>
                    <CardHeader
                        title={t("All Communities Map")}
                        className="text-left"
                        action={
                        <IconButton color="primary" className='customIconButton' aria-label="close" component="span" onClick={() => this.setState({ showMapView: false })}>
                            <CloseOutlined />
                        </IconButton>
                        }
                        sx={{paddingBottom:'0px'}}
                    />
                    <CardContent>
                            <div className="map-container">
                                <LoadScript googleMapsApiKey={'AIzaSyCFqWukKnjwW2mFD8Yied3129Dic2TRWH4'}>
                                <GoogleMap
                                    mapContainerStyle={{ height: '80vh', width: '100%' }}
                                    zoom={5.3}
                                    center={this.state.defaultMapCenter} 
                                >
                                    {/* No need for Marker components anymore */}
                                    {this.state.markers.map((marker, index) => (
                                                <Marker
                                                    key={index}
                                                    position={{ lat: marker.lat, lng: marker.lng }}
                                                    // label={marker.label}
                                                />
                                            ))}
                                </GoogleMap>
                                </LoadScript>
                            </div>
                        </CardContent>
                    </Card>
                </Box>
                </Modal>
                <Modal
                    open={this.state.showCreateUsers}
                    onClose={() => this.setState({ showCreateUsers: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={"Create Users"}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showCreateUsers: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <Autocomplete
                                            id="combo-box-demo"
                                            fullWidth={true}
                                            options={this.state.routes}
                                            value={this.state.userCommunity?.id}
                                            onChange={(value: any, newValue: any) => this.setState({userCommunity: newValue.id})}
                                            getOptionLabel={(options: any) => options.name}
                                            renderInput={(params) => <TextField {...params} label="Community" />}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label="Count"
                                            value={this.state.userCount}
                                            onChange={(e: any) => this.setState({ userCount: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showCreateUsers: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => createBulkUsers()}>Create Users</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showEditCommunityTemplate}
                    onClose={() => this.setState({ showEditCommunityTemplate: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Community Template")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showEditCommunityTemplate: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="demo-multiple-chip-label">Pickup Days</InputLabel>
                                            <Select
                                                labelId="demo-multiple-chip-label"
                                                id="demo-multiple-chip"
                                                multiple
                                                value={this.state.pickupDays}
                                                onChange={handleChange}
                                                // disabled={this.state.pickupDays[0]}
                                                input={<OutlinedInput id="select-multiple-chip" label="Pickup Days" />}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {(selected ?? []).slice(0, 2).map((value: any) => (
                                                            <Chip key={value} label={value} />
                                                        ))}
                                                        {selected.length > 2 && <Typography style={{ marginTop: '4px' }}>{" +"}{selected.length - 2}</Typography>}
                                                    </Box>
                                                )}
                                                >
                                                {this.state.weekDays?.map((day: any) => (
                                                    <MenuItem
                                                        key={day}
                                                        value={day}
                                                        // style={getStyles(name, this.state.personName, theme)}
                                                        >
                                                        {day}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="type-label">Slot</InputLabel>
                                            <Select
                                                labelId="type-label"
                                                value={this.state.pickupSlot}
                                                onChange={(e) => this.setState({ pickupSlot: e.target.value })}
                                                displayEmpty
                                                label="Slot"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={20} value={20}>Morning</MenuItem>
                                                <MenuItem key={21} value={21}>Afternoon</MenuItem>
                                                <MenuItem key={22} value={22}>Evening</MenuItem>
                                                {/* <MenuItem key={23} value={23}>Testing</MenuItem> */}

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="type-label">Pickup Agent</InputLabel>
                                            <Select
                                                labelId="type-label"
                                                value={this.state.pickupAgent}
                                                onChange={(e) => this.setState({ pickupAgent: e.target.value })}
                                                displayEmpty
                                                label="Pickup Agent"
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.agents?.map((el: any) => {
                                                        return(
                                                            <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
                                                            )
                                                        })
                                                    }

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    mask="____-__-__"
                                                    views={['year', 'month', 'day']}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("Distribution Date")}
                                                    value={this.state.distributionDate}
                                                    // disabled={this.state.distributionDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ distributionDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="type-label">Distribution Agent</InputLabel>
                                            <Select
                                                labelId="type-label"
                                                value={this.state.distributionAgent}
                                                onChange={(e) => this.setState({ distributionAgent: e.target.value })}
                                                displayEmpty
                                                label="Distribution Agent"
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.agents?.map((el: any) => {
                                                        return(
                                                            <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
                                                            )
                                                        })
                                                    }

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} style={{paddingTop: "15px"}}>
                                    <Grid item md={4} xs={4} >
                                        <FormControlLabel
                                            value="start"
                                            control={<Switch color="primary" checked={this.state.pickupEnabled} onChange={() => this.setState({pickupEnabled: !this.state.pickupEnabled})} />}
                                            label="Pickup Enabled"
                                            labelPlacement="start"
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={4}>
                                        <FormControlLabel
                                            value="start"
                                            control={<Switch color="primary" checked={this.state.bagDistributionEnabled} onChange={() => this.setState({bagDistributionEnabled: !this.state.bagDistributionEnabled})} />}
                                            label="Bag Distribution Enabled"
                                            labelPlacement="start"
                                        />
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showEditCommunityTemplate: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleSetCommunityTemplate()}>{this.state.flagEditTemplate  ? "Edit Template" : "Create Template"}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Dialog
                    open={this.state.showDeleteDialogue}
                    onClose={() => this.setState({ showDeleteDialogue: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to delete this community ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showDeleteDialogue: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => deleteCommunity(this.state.community_id)} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.showToggleDialogBox}
                    onClose={() => this.setState({ showToggleDialogBox: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to")} {this.state.toggleCommunityStatus == 1 ? t("Inactivate") : t("Activate")} {t("this community?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showToggleDialogBox: false, toggleCommunityId: '', toggleCommunityStatus: '' })}>{t("Cancel")}</Button>
                        <Button onClick={() => this.toggleCommunityStatus()} autoFocus>{this.state.toggleCommunityStatus == 1 ? "Inactivate" : "Activate"}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(NeighbourhoodList))
